<template>
    <gmap-map
        ref="map"
        :center="center"
        :zoom="zoomValue"
        :style="mapStyle"
        :options="mapOptions"
        @boundsChanged="$emit('boundsChanged')"
        @idle="centerOnLoad"
    >
        <slot />
    </gmap-map>
</template>

<script>
    export default {
        props: {
            mapStyle: {
                required: false,
                type: String,
                default: '',
            },
            defaultCenter: {
                required: false,
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            zoom: {
                required: false,
                type: [Number, String],
                default: 4,
            },
            markers: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                },
            },
        },
        data() {
            return {
                centerIssetFromUserPosition: false,
                center: this.defaultCenter,
                initialLoad: true,
                localZoom: this.zoom,
            };
        },
        computed: {
            mapOptions() {
                return {
                    disableDefaultUI : false,
                };
            },
            zoomValue() {
                return parseInt(this.localZoom);
            },
        },
        watch: {
            markers() {
                this.fitToBounds();
            },
        },
        mounted() {
            EventBus.$on('userLocationAcquired', userPositionMarker => {
                this.$nextTick(() => {
                    this.$refs.map.$mapPromise.then(() => {
                        // Make sure we don't fit to bounds if we have user location
                        this.centerIssetFromUserPosition = true;

                        this.center = userPositionMarker.position;
                        this.localZoom = this.zoom + 1;
                    });
                });
            });
        },
        methods: {
            centerOnLoad() {
                if (! this.centerIssetFromUserPosition && this.initialLoad && this.markers.length) {
                    this.initialLoad = false;
                    this.fitToBounds();
                }
            },
            fitToBounds() {
                if (this.$refs.map && window.google && this.markers.length > 0) {
                    const map = this.$refs.map;
                    const bounds = new google.maps.LatLngBounds();

                    this.markers.forEach(marker => {
                        if (marker.position) {
                            const position = new google.maps.LatLng(marker.position);
                            bounds.extend(position);
                        }
                    });

                    map.$mapObject.fitBounds(bounds);

                    if (this.markers.length < 2) {
                        // Since we use fit to bounds we get an insane
                        // zoom level if we have only one marker, thus
                        // we need to set the zoom value again to something else
                        // in order to zoom out again.
                        this.localZoom = this.zoom + 1;
                    }
                }
            },
        },
    };
</script>
